import React, { Component } from 'react'
import { BusinessCenter, Chat, HelpOutline, InsertDriveFile, LaptopChromebook, LocalLibrary, MailOutline, Phone, School, SupervisorAccount, Timeline } from '@mui/icons-material'

export function getLinkIcon(iconType) {
  switch (iconType) {
    case 'ActionHelpOutline':
      return <HelpOutline className="btn-pointer-events" />
    case 'ActionSupervisorAccount':
      return <SupervisorAccount className="btn-pointer-events" />
    case 'ActionTimeline':
      return <Timeline className="btn-pointer-events" />
    case 'HardwareLaptopChromebook':
      return <LaptopChromebook className="btn-pointer-events" />
    case 'PlacesBusinessCenter':
      return <BusinessCenter className="btn-pointer-events" />
    case 'MapsLocalLibrary':
      return <LocalLibrary className="btn-pointer-events" />
    case 'CommunicationPhone':
      return <Phone className="btn-pointer-events" />
    case 'CommunicationChat':
      return <Chat className="btn-pointer-events" />
    case 'CommunicationMailOutline':
      return <MailOutline className="btn-pointer-events" />
    case 'EditorInsertDriveFile':
      return <InsertDriveFile className="btn-pointer-events" />
    default:
      return <School className="btn-pointer-events" />
  }
}

export const buildLink = (key, attributes) => (
  <a
    key={key}
    className="link-container"
    href={attributes.field_hamburger_link.uri}
    disabled={attributes.isDisabled}
    onClick={attributes.field_hamburger_link.onclick}
  >
    <div className="link-icon">
      {getLinkIcon(attributes.field_icon_svg)}
      {attributes.field_hamburger_link.title}
    </div>
  </a>
)

export default class UsefulLinks extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // usefulLinks: [],
      chatStates: [
        {
          text: '',
          wait: 0,
          available: 1
        },
        {
          text: '',
          wait: 1,
          available: 0
        },
        {
          text: "We're sorry, chat is currently unavailable.",
          outOfHours: true
        }
      ],
      chatStateText: "We're sorry, chat is currently unavailable.",
      loadSubscribe: false,
      chatActive: false
    }
  }
  componentDidMount() {
    try {
      if (window.RightNow.Client.Event.evt_dataRequest) {
        this.subscribeToEvents()
      }
    } catch (e) {
      let timeoutID = window.setTimeout(this.subscribeToEvents, 2000)
      this.setState({
        loadSubscribe: timeoutID
      })
    }
  }

  updateChatState = (updateResult, instance) => {
    let currState = updateResult[0].data.stats
    let chatActive = true
    let foundState = instance.state.chatStates.find(item => {
      if (currState.out_of_hours) {
        chatActive = false
        return true
      } else if (
        parseInt(currState.availableSessionCount, 10) >= item.available &&
        parseInt(currState.expectedWaitSeconds, 10) === item.wait
      ) {
        return true
      } else if (
        parseInt(currState.availableSessionCount, 10) >= item.available &&
        parseInt(currState.expectedWaitSeconds, 10) >= item.wait
      ) {
        return true
      }

      return false
    })

    if (foundState) {
      instance.setState({
        chatStateText: foundState.text,
        chatActive: chatActive
      })
    }
  }

  initialiseUsefulLinks(eventType, args, instance) {
    if (args && typeof args === 'object') {
      instance.updateChatState(args, instance)
    }
  }

  subscribeToEvents = () => {
    if (window.RightNow.Client.Event.evt_dataRequest) {
      window.RightNow.Client.Event.evt_conditionalChatLinkAvailabilityResponse.subscribe(
        this.initialiseUsefulLinks,
        this
      )

      let timeoutID = this.state.timeoutID
      this.setState(
        {
          loadSubscribe: true
        },
        function(timeoutID) {
          window.clearTimeout(timeoutID)
        }
      )
    }
  }

  render() {
    return (
      <div>
        <div className="slidein__subsection">
          <h2 className="slidein__section-subheading">Need help?</h2>
          <p>
            If you have questions, please contact us via any of the methods
            below
          </p>
          <div className="slidein__linkout">
            {this.props.usefulLinks.map((item, index) => {
              if (item.attributes.field_hamburger_link) {
                if (
                  item.attributes.field_type === 'chat' &&
                  this.state.loadSubscribe === true
                ) {
                  if (!this.state.chatActive) {
                    item.isDisabled = !this.state.chatActive
                    item.attributes.field_hamburger_link.uri =
                      item.attributes.field_hamburger_link.uri_default
                  } else if (
                    document.getElementById('rn_sccl_0_Link') !== null
                  ) {
                    item.attributes.field_hamburger_link.uri_default =
                      item.attributes.field_hamburger_link.uri
                    item.attributes.field_hamburger_link.uri =
                      'javascript:void(0);'
                    item.attributes.field_hamburger_link.onclick = document.getElementById(
                      'rn_sccl_0_Link'
                    ).onclick
                    item.attributes.isDisabled = false
                  }
                }
                return buildLink(index, item.attributes)
              }
            })}
            {this.props.usefulLinks.length % 2 === 1 && (
              <a className="link-container" />
            )}
          </div>
          {this.props.usefulLinks.some(
            link => link.attributes && link.attributes.field_type === 'chat'
          ) && (
            <div className="chatStatusText">
              <p>{this.state.chatStateText}</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}
